/* @flow */

import { makeListLink } from './utils';

export default makeListLink({ pathname: '/help', children: 'help' });



// WEBPACK FOOTER //
// ./src/packages/@ncigdc/components/Links/HelpLink.js